import { axiosInstance } from './config';

export type SiweMessageResponse = {
  message: string;
  nonce: string;
};

export const authAPIService = {
  // Legacy endpoints (kept for backward compatibility)
  getNonce: async (ethAddress: string) => {
    return axiosInstance.post<{ nonce: string }>('/auth/nonce', { ethAddress });
  },
  login: async (ethAddress: string, signature: string) => {
    return axiosInstance.post<{ data: string }>('/auth/token', { ethAddress, signature });
  },

  // SIWE (EIP-4361) endpoints
  getSiweMessage: async (ethAddress: string, chainId?: number) => {
    return axiosInstance.post<SiweMessageResponse>('/auth/siwe-message', { ethAddress, chainId });
  },
  verifySiweSignature: async (message: string, signature: string) => {
    return axiosInstance.post<{ data: string }>('/auth/siwe-verify', { message, signature });
  },

  refreshToken: async () => {
    return axiosInstance.post<{ data: string }>('/auth/refresh-token');
  },
  logout: async () => {
    return axiosInstance.post<{ data: string }>('/auth/clear');
  },
};
